import React, { Component } from "react";
import Home from "./components/Home/Home.js";
import HowItWorks from "./components/HowItWorks/HowItWorks.js";
import SelectCharity from "./components/SelectCharity/SelectCharity.js";
import Details from "./components/Details/Details.js";
import Message from "./components/Message/Message.js";
import Payment from "./components/Payment/Payment.js";
import Review from "./components/Review/Review.js";
import Response from "./components/Response/Response.js";
import Why from "./components/Pages/Why.js";
import FAQ from "./components/Pages/FAQ.js";
import Legal from "./components/Pages/Legal.js";
import Privacy from "./components/Pages/Privacy.js";
import ContactUs from "./components/Pages/ContactUs.js";
import RotatePlaceholder from "./components/Pages/RotatePlaceholder.js";

import MediaQuery from "react-responsive";

/** REMOVE ME */
import ConfirmationMobile from "./components/Review/ConfirmationMobile";
import BummerMobile from "./components/Review/BummerMobile";
import SuccessMobile from "./components/Review/SuccessMobile";
/*  */
import {
  Router,
  Route,
  hashHistory,
  IndexRoute,
  applyRouterMiddleware
} from "react-router";
import { syncHistoryWithStore } from "react-router-redux";
//Redux
import { Provider } from "react-redux";
import allReducers from "./reducers/reducers.js";
import configureStore from "./configureStore";

import { Header, Menu, Footer } from "./components/Controls";
import logoImage from "./assets/images/2018/Logo.png";

import ReactGA from "react-ga";

const store = configureStore();
const history = syncHistoryWithStore(hashHistory, store);

ReactGA.initialize("UA-91385028-1");

const logPageView = () => {
  ReactGA.set({ page: window.location.hash });
  ReactGA.pageview(window.location.hash);
  window.scrollTo(0, 0);
};

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuToggled: false
    };
  }

  toggleMenu() {
    this.setState({
      menuToggled: !this.state.menuToggled
    });
  }

  render() {
    let {
      location: { pathname }
    } = this.props;
    return (
      <div className="page">
        <MediaQuery maxDeviceWidth={740}>
          <div className="mobile-wrapper">
            <Header
              path={pathname}
              isMobile={true}
              toggleMenu={() => this.toggleMenu()}
              menuToggled={this.state.menuToggled}
            />
            <Menu
              toggleMenu={() => this.toggleMenu()}
              toggled={this.state.menuToggled}
            />
            <div className="content">{this.props.children}</div>
            <Footer showNavigation={pathname !== "/"} />
            <RotatePlaceholder />
          </div>
        </MediaQuery>
        <MediaQuery minDeviceWidth={741}>
          <div className="desktop-wrapper">
            <Header
              path={pathname}
              toggleMenu={() => this.toggleMenu()}
              menuToggled={this.state.menuToggled}
            />
            <Menu
              isDesktop={true}
              toggleMenu={() => this.toggleMenu()}
              toggled={this.state.menuToggled}
            />

            <div className="content">{this.props.children}</div>
            <Footer showNavigation={true} />
          </div>
        </MediaQuery>
      </div>
    );
  }
}

export default (
  <Provider store={store}>
    <Router history={history} onUpdate={logPageView}>
      <Route path="/" component={App}>
        <IndexRoute component={Home} />
        <Route path="/how" component={HowItWorks} />
        <Route path="/response/:id" component={Response} />
        <Route path="/proceed" component={SelectCharity} />
        <Route path="/details/:section" component={Details} />
        <Route path="/message" component={Message} />
        <Route path="/payment" component={Payment} />
        <Route path="/review" component={Review} />
        <Route path="/mission" component={Why} />
        <Route path="/faq" component={FAQ} />
        <Route path="/legal" component={Legal} />
        <Route path="/contact" component={ContactUs} />
        <Route path="/privacy" component={Privacy} />
        <Route path="/success" component={SuccessMobile} />
        <Route path="/bumer" component={BummerMobile} />
        <Route path="/confirmation" component={ConfirmationMobile} />
      </Route>
    </Router>
  </Provider>
);



// WEBPACK FOOTER //
// ./App.js